// extracted by mini-css-extract-plugin
export default {"title":"String_title__jDA0c","header":"String_header__zJOWB","string":"String_string__8mQe2"};